import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS'
import { UI_PROGRAM } from '../../../constants/state'
import getData from '../../../functions/getData'
import OverlayEditSelection from '../presentational/OverlayEditSelection';


const mapStateToProps = state => ({
    isEditingSelection: getData(state, [UI_PROGRAM, 'editSelection']),
})

const OverlayEditSelectionContainer = ({isEditingSelection}) => <OverlayEditSelection
    isEditingSelection={isEditingSelection}
/>

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(OverlayEditSelectionContainer)